import React from 'react';

import { fg } from '@confluence/feature-gating';

import { Bm3PageSegmentLoadStart } from '../Bm3PageSegmentLoadStart.tsx';
import type { PageSegmentLoadStartProps } from '../Bm3PageSegmentLoadStart.tsx';

import { UFOSegmentLoadStart } from './UFOSegmentLoadStart.tsx';

/**
 * Interop component that renders either the new UFOSegmentLoadStart (which
 * retains SSR marking and onComplete callback) or the legacy Bm3PageSegmentLoadStart
 * (which starts BM3 metrics) based on the `confluence_fe_deprecate_bm3` feature gate.
 */
export const PageSegmentLoadStart = (props: PageSegmentLoadStartProps) => {
	if (fg('confluence_fe_deprecate_bm3')) {
		return <UFOSegmentLoadStart {...props} />;
	}

	return <Bm3PageSegmentLoadStart {...props} />;
};
